import { useState } from "react";
import axios from "axios";
import { Dropdown, DropdownButton, Form, Spinner } from "react-bootstrap";
import { NEW_API_URL } from "../../constants/Globals";

const AiPromptSettings = ({ selNetworkId, onSuccess }) => {
  const [formData, setFormData] = useState({
    flowType: null,
    systemPrompt: "",
    userPrompt: "",
  });

  const [loading, setLoading] = useState(false);
  const [initialLoad, setInitialLoad] = useState(false);

  const flowTypes = [
    { value: "Poll generator", label: "Poll Generator" },
    { value: "Tag generator", label: "Tag Generator" },
    { value: "Sequence generator", label: "Sequence Generator" },
    { value: "Sequence tag generator", label: "Sequence Tag Generator" },
  ];

  const getFlowTypeLabel = (value) => {
    const match = flowTypes.find((t) => t.value === value);
    return match ? match.label : "Select Flow Type";
  };

  const validateForm = () => {
    return (
      formData.flowType &&
      formData.systemPrompt.trim() !== "" &&
      formData.userPrompt.trim() !== ""
    );
  };

  const fetchPromptByFlowType = async (flowType) => {
    setLoading(true);
    try {
      const response = await axios.get(
        `${NEW_API_URL}/ai-prompts/${encodeURIComponent(flowType)}`
      );
      if (response.data && response.data.data) {
        const data = response.data.data;
        setFormData({
          flowType: data.flowType,
          systemPrompt: data.systemPrompt || "",
          userPrompt: data.userPrompt || "",
        });
      } else {
        setFormData((prev) => ({
          ...prev,
          flowType,
          systemPrompt: "",
          userPrompt: "",
        }));
      }
    } catch (error) {
      setFormData((prev) => ({
        ...prev,
        flowType,
        systemPrompt: "",
        userPrompt: "",
      }));
    } finally {
      setLoading(false);
      setInitialLoad(true);
    }
  };

  const handleSavePrompt = async () => {
    try {
      const response = await axios.post(`${NEW_API_URL}/ai-prompts`, formData);
      if (response.status === 201 || response.status === 200) {
        if (onSuccess) onSuccess();
        alert("AI Prompt saved successfully.");
      }
    } catch (error) {
      console.error("Error saving AI Prompt:", error);
      alert("Failed to save prompt. Check console for details.");
    }
  };

  return (
    <div className="container mt-4">
      <div className="page-headline">
        <strong>AI Prompt Settings</strong>
      </div>

      <Form.Group className="mb-3">
        <Form.Label>Flow Type</Form.Label>
        <DropdownButton
          id="flowType"
          className="standard-dropdown"
          title={getFlowTypeLabel(formData.flowType)}
        >
          {flowTypes.map((type) => (
            <Dropdown.Item
              key={type.value}
              onClick={() => fetchPromptByFlowType(type.value)}
            >
              {type.label}
            </Dropdown.Item>
          ))}
        </DropdownButton>
      </Form.Group>

      {loading && !initialLoad ? (
        <div className="text-center my-3">
          <Spinner animation="border" />
        </div>
      ) : (
        <>
          <Form.Group className="mb-3">
            <Form.Label>System Prompt</Form.Label>
            <Form.Control
              as="textarea"
              rows={3}
              value={formData.systemPrompt}
              onChange={(e) =>
                setFormData((prev) => ({
                  ...prev,
                  systemPrompt: e.target.value,
                }))
              }
              placeholder="Enter system prompt"
            />
          </Form.Group>

          <Form.Group className="mb-3">
            <Form.Label>User Prompt</Form.Label>
            <Form.Control
              as="textarea"
              rows={3}
              value={formData.userPrompt}
              onChange={(e) =>
                setFormData((prev) => ({
                  ...prev,
                  userPrompt: e.target.value,
                }))
              }
              placeholder="Enter user prompt"
            />
          </Form.Group>

          <div className="text-end">
            <button
              className="btn btn-primary"
              onClick={handleSavePrompt}
              disabled={!validateForm()}
            >
              Save Prompt
            </button>
          </div>
        </>
      )}
    </div>
  );
};

export default AiPromptSettings;
